// extracted by mini-css-extract-plugin
export default {"icon":"ED0fTilVgM7L0VflP2IA"};